import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';

import Icon from '../common/Icon';
import { useMBDContext } from '../common/MBD/useMBDContext';

import type { ConfigurableLink as ConfigurableLinkProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationInfoCardsProps';

// Tracking common-param string values over ~40 chars are silently dropped by
// the MBD pipeline, so we truncate the link text before sending it.
const MAX_TRACKED_TEXT_LENGTH = 40;

type ConfigurableLinkWithIndexProps = ConfigurableLinkProps & {
  cardIndex: number;
  linkIndex: number;
};

const ConfigurableLink = ({
  cardIndex,
  icon,
  link,
  linkIndex,
  text,
}: ConfigurableLinkWithIndexProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();
  const mbdComponentName = `${rawComponentName}_item_link`;
  let IconComponent;

  if (icon) {
    IconComponent = Icon(icon, 'small');
  }

  return (
    <BpkLink
      key={link}
      href={link}
      data-tracking-element-id={`${mbdComponentName}_${cardIndex}_${linkIndex}`}
      data-tracking-common-params={buildMBDParam(mbdComponentName, {
        link_text: text.slice(0, MAX_TRACKED_TEXT_LENGTH),
      })}
    >
      <IconComponent /> {text}
    </BpkLink>
  );
};

export default ConfigurableLink;
